import { useEffect, useRef } from "react";
/**
 * This hook helps set up a function that will be called whenever
 * the specific event is delivered to the window object.
 */
export var useWindowEventListener = function (type, event, dependencies, allowDuplicated) {
    if (dependencies === void 0) { dependencies = []; }
    if (allowDuplicated === void 0) { allowDuplicated = false; }
    var eventListener = useRef();
    useEffect(function () {
        if (!allowDuplicated && eventListener.current) {
            window.removeEventListener(type, eventListener.current);
            eventListener.current = undefined;
        }
        eventListener.current = event;
        window.addEventListener(type, eventListener.current);
        return function () {
            if (eventListener.current) {
                window.removeEventListener(type, eventListener.current);
                eventListener.current = undefined;
            }
        };
    }, dependencies);
};
